import React, { useState ,useEffect} from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import MenuIcon from "@mui/icons-material/Menu";
import boostboardlogo from "../../Assets/svgs/boostboard_logo.svg";
import Button from "react-bootstrap/Button";
import { captureeventbaseanalytics } from "../../Libraries/Media";
import { Link , useLocation} from "react-router-dom";
import "./Navbar.css";

function Navbars() {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");
  console.log(`Active link in navbar: ${activeLink}`);

  useEffect(() => {
    if (location.hash) {
      setActiveLink(location.hash); 
    } else {
      setActiveLink("");
    }
  }, [location.hash]);

  const handleLinkClick = (link, label) => {
    setActiveLink(link);
    captureeventbaseanalytics(
      "Landing",
      `BoostBoard_Navbar_${label}`,
      `User clicked on ${label}`
    );
  };

  const handleLoginClick = () => {
    captureeventbaseanalytics(
      "Landing",
      "BoostBoard_Navbar_Login",
      "User clicked on Login button"
    );
  };

  const handleSignupClick = () => {
    captureeventbaseanalytics(
      "Landing",
      "BoostBoard_Navbar_Signup",
      "User clicked on Signup button"
    );
  };

  return (
    <Navbar
      expand="md"
      className="bg-body-tertiary border-0 custom-navbar"
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="#">
          <img
            src={boostboardlogo}
            alt="Brand Logo"
            width="130"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
        <Navbar.Toggle className="custom-toggle navbar-toggle">
          <MenuIcon />
        </Navbar.Toggle>
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="ms-auto my-4 my-lg-0 d-flex flex-row justify-content-center"
            style={{ flexWrap: "wrap" }}
            navbarScroll
          >
             <Nav.Link
              as={Link}
              to="/landingpage#Solution"
              className={`mx-3 navLink-space navLink ${activeLink === "#Solution" ? "active" : ""}` }
              onClick={() => handleLinkClick("#Solution", "Solution")}
            >
              Solution
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/landingpage#Features"
              className={`mx-3 navLink-space navLink ${activeLink === "#Features" ? "active" : ""}`}
              onClick={() => handleLinkClick("#Features", "Features")}
            >
              Features
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/landingpage#Industries"
              className={`mx-3 navLink-space navLink ${activeLink === "#Industries" ? "active" : ""}`}
              onClick={() => handleLinkClick("#Industries", "Industries")}
            >
              Industries
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/landingpage#support"
              className={`mx-3 navLink-space navLink ${activeLink === "#support" ? "active" : ""}`}
              onClick={() => handleLinkClick("#support", "support")}
            >
              Support
            </Nav.Link>

            <Button
              variant="outline-primary"
              className="get_started_btn capitalized fs-14 fw-bold"
              size="md"
              href="login"
              target="_blank"
              onClick={handleLoginClick}
            >
              Login
            </Button>
            <Button
              variant="primary"
              className="signup-btn capitalized fs-14 fw-bold"
              size="md"
              href="signup"
              target="_blank"
              onClick={handleSignupClick}
            >
              Signup
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbars;

